import React from 'react';
import { MapPinIcon, CalendarIcon, ShieldIcon, UserPlusIcon, ArrowRightIcon, TargetIcon, TreesIcon, HomeIcon, AwardIcon, BowArrowIcon, LogInIcon } from 'lucide-react';
const highlights = [{
  icon: TargetIcon,
  text: '24/7 Indoor Pistol Range (6 lanes)'
}, {
  icon: TargetIcon,
  text: 'Outdoor Ranges: 25, 50 & 100 Yards'
}, {
  icon: TreesIcon,
  text: 'Sporting Clays — Public Weekends'
}, {
  icon: BowArrowIcon,
  text: 'Archery & 3-D Archery Course'
}, {
  icon: AwardIcon,
  text: 'NRA Certified Firearms Training'
}, {
  icon: HomeIcon,
  text: 'Clubhouse Rental — Up to 300 Guests'
}];
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" style={{
    minHeight: '540px',
    background: 'linear-gradient(135deg, #0f2318 0%, #1e3d2f 40%, #2d5a3d 80%, #1a3528 100%)'
  }} aria-label="Fenton Lakes Sportsman's Club" data-id="element-1737">
      <div className="absolute inset-0 texture-overlay opacity-40" aria-hidden="true" data-id="element-1738" />
      <div className="absolute right-0 top-0 bottom-0 w-1/3 hidden lg:block" style={{
      background: 'linear-gradient(135deg, transparent 0%, rgba(200,168,75,0.05) 100%)',
      clipPath: 'polygon(30% 0%, 100% 0%, 100% 100%, 0% 100%)'
    }} aria-hidden="true" data-id="element-1739" />
      <div className="w-full h-1" style={{
      backgroundColor: '#c8a84b'
    }} aria-hidden="true" data-id="element-1740" />

      <div className="relative z-10 flex justify-center pt-4 px-4" data-id="element-1741">
        <a href="/police-pistol-combat-match" className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold transition-all hover:opacity-90" style={{
        backgroundColor: 'rgba(200,168,75,0.15)',
        border: '1px solid rgba(200,168,75,0.45)',
        color: '#c8a84b',
        fontFamily: 'Inter, sans-serif',
        backdropFilter: 'blur(4px)'
      }} data-id="element-1742">
          <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
          backgroundColor: '#c8a84b'
        }} data-id="element-1743" />
          Featured Event: FLSC Police Pistol Combat Match &nbsp;·&nbsp; March
          12–15, 2026
          <ArrowRightIcon size={11} data-id="element-1744" />
        </a>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-14 flex flex-col lg:flex-row items-start gap-10 lg:gap-14" data-id="element-1745">
        <div className="flex-1" data-id="element-1746">
          <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1747">
            Shooting Sports &amp; Outdoor Recreation in Fenton, Michigan
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-4 leading-tight" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#ffffff'
        }} data-id="element-1748">
            Fenton Lakes
            <br data-id="element-1749" />
            <span style={{
            color: '#c8a84b'
          }} data-id="element-1750">
              Sportsman's Club
            </span>
          </h1>
          <p className="text-base md:text-lg leading-relaxed mb-7 max-w-xl" style={{
          color: '#c8d8cc',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1751">
            A member-supported club on 70+ acres just north of Fenton, offering
            indoor &amp; outdoor shooting ranges, sporting clays, archery, and
            NRA-led firearms training — serving the community since 1953.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-8 max-w-xl" data-id="element-1752">
            {highlights.map(({
            icon: Icon,
            text
          }) => <div key={text} className="flex items-center gap-2" data-id="element-1753">
                <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(200,168,75,0.18)'
            }} data-id="element-1754">
                  <Icon size={11} style={{
                color: '#c8a84b'
              }} data-id="element-1755" />
                </div>
                <span className="text-sm" style={{
              color: '#c8d8cc',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1756">
                  {text}
                </span>
              </div>)}
          </div>
          <div className="flex flex-wrap gap-3 items-center" data-id="element-1757">
            <a href="#member-login" className="inline-flex items-center gap-2 px-7 py-3.5 rounded font-semibold text-base transition-all hover:opacity-90 active:scale-95" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1758">
              <LogInIcon size={16} data-id="element-1759" />
              Members Login Here
            </a>
            <a href="/Calendar.html" className="inline-flex items-center gap-2 px-6 py-3.5 rounded font-medium text-base border transition-all hover:bg-white/10" style={{
            borderColor: 'rgba(255,255,255,0.28)',
            color: '#e8e4d8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1760">
              <CalendarIcon size={16} data-id="element-1761" />
              View Calendar
            </a>
            <a href="/RangeRules.html" className="inline-flex items-center gap-1.5 text-sm font-medium transition-all hover:opacity-80" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1762">
              <ShieldIcon size={13} data-id="element-1763" />
              Range Rules
            </a>
          </div>
          <div className="mt-4" data-id="element-1764">
            <a href="https://www.google.com/maps/place/Fenton+Lakes+Sportsmans+Club/@42.8417739,-83.6964788,17z/data=!3m1!4b1!4m5!3m4!1s0x882364b491bd2837:0xd11b08e813df5c17!8m2!3d42.8417732!4d-83.6941837?hl=en-US" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs transition-all hover:opacity-80" style={{
            color: '#7a9a8a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1765">
              <MapPinIcon size={12} data-id="element-1766" />
              1140 Butcher Rd, Fenton, MI — Get Directions
            </a>
          </div>
        </div>

        <div className="w-full lg:w-72 xl:w-80 rounded-2xl overflow-hidden flex-shrink-0 shadow-2xl" style={{
        border: '1px solid rgba(200,168,75,0.25)',
        backgroundColor: 'rgba(15,35,24,0.7)',
        backdropFilter: 'blur(10px)'
      }} data-id="element-1767">
          <div className="px-6 py-4" style={{
          backgroundColor: '#c8a84b'
        }} data-id="element-1768">
            <p className="text-sm font-bold uppercase tracking-wider" style={{
            color: '#1a1a1a',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-1769">
              New Here?
            </p>
            <p className="text-xs mt-0.5" style={{
            color: 'rgba(26,26,26,0.7)',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1770">
              Everything you need to get started
            </p>
          </div>
          <div className="px-6 py-5 space-y-3" data-id="element-1771">
            <a href="/Apply-For-Membership" className="flex items-center gap-3 w-full py-3 px-4 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1772">
              <UserPlusIcon size={15} data-id="element-1773" />
              Apply for Membership
            </a>
            <a href="/RangeRules.html" className="flex items-center gap-3 w-full py-3 px-4 rounded-lg text-sm font-medium border transition-all hover:bg-white/10" style={{
            borderColor: 'rgba(255,255,255,0.18)',
            color: '#e8e4d8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1774">
              <ShieldIcon size={15} data-id="element-1775" />
              Range Rules
            </a>
            <a href="/Calendar.html" className="flex items-center gap-3 w-full py-3 px-4 rounded-lg text-sm font-medium border transition-all hover:bg-white/10" style={{
            borderColor: 'rgba(255,255,255,0.18)',
            color: '#e8e4d8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1776">
              <CalendarIcon size={15} data-id="element-1777" />
              View Calendar
            </a>
            <a href="/ContactUs.html" className="flex items-center gap-3 w-full py-3 px-4 rounded-lg text-sm font-medium border transition-all hover:bg-white/10" style={{
            borderColor: 'rgba(255,255,255,0.18)',
            color: '#e8e4d8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1778">
              <ArrowRightIcon size={15} data-id="element-1779" />
              Contact Us
            </a>
          </div>
          <div className="px-6 py-4 space-y-1.5" style={{
          borderTop: '1px solid rgba(255,255,255,0.08)',
          backgroundColor: 'rgba(0,0,0,0.2)'
        }} data-id="element-1780">
            <p className="text-xs font-bold uppercase tracking-wider mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-1781">
              Range Hours
            </p>
            <p className="text-xs" style={{
            color: '#a0b8a8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1782">
              <span style={{
              color: '#e8e4d8'
            }} data-id="element-1783">
                Outdoor:
              </span>{' '}
              Mon–Sat 9am–Sundown · Sun 9am–5pm
            </p>
            <p className="text-xs" style={{
            color: '#a0b8a8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1784">
              <span style={{
              color: '#e8e4d8'
            }} data-id="element-1785">
                Indoor:
              </span>{' '}
              24/7 for Members &amp; Guests
            </p>
            <p className="text-xs" style={{
            color: '#a0b8a8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1786">
              <span style={{
              color: '#e8e4d8'
            }} data-id="element-1787">
                Sporting Clays:
              </span>{' '}
              Sat &amp; Sun 10am–3pm (public)
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0" aria-hidden="true" data-id="element-1788">
        <svg viewBox="0 0 1440 40" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: 'block',
        width: '100%',
        height: '40px'
      }} data-id="element-1789">
          <path d="M0 40L1440 40L1440 20C1200 0 960 40 720 20C480 0 240 40 0 20L0 40Z" fill="#f8f6f0" data-id="element-1790" />
        </svg>
      </div>
    </section>;
}